import axios from 'axios';
import type {
  IGetOverdueBalanceParams,
  IGetOverdueBalanceRequest,
  IGetOverdueBalanceResponse,
} from '@/app-package';

const getOverdueBalance = async (params: IGetOverdueBalanceParams) => {
  const config: IGetOverdueBalanceRequest = {
    url: `/billing/get_balance/${params.billingCustomerNumber}`,
    method: 'get',
  };
  try {
    const { data } = await axios.request<IGetOverdueBalanceResponse | null>(
      config,
    );
    return data;
  } catch (error: any) {
    // Check for 404 error and return a nulled object
    if (error.response && error.response.status === 404) {
      return {
        outstandingBalance: null,
        currencyCode: null,
        paymentDueDate: null,
      };
    }
    throw error;
  }
};

export default getOverdueBalance;
